



export function admin(){

     return [
        'providers',
        'admin',
    ]
   
}


export function adminApp(){

     return [
        'home',
        'goku',
        'providers'
    ]
   
}


export function staff() {
    return [
       { sensitive: 'purchase', public: 'Purchase' },
       { sensitive: 'sale', public: 'Sales' },
       { sensitive: 'inventory', public: 'Inventory' },
       { sensitive: 'customer', public: 'Entities' },
       { sensitive: 'transaction', public: 'Finances' }
   ];
}





/*

export function admin(){

     return [
        'home',
        'homestaff',
        'goku',
        'powers',
        'monitor',
        'users',
    ]
   
}


export function adminApp(){

     return [
        'home',
        'goku',
    ]
   
}


export function staff(){

     return [
        'homestaff',
        'goku',
        'powers',
        'monitor',
        'users',
    ]
   
}




*/